
import { PartnerColor } from "@/lib/partnerColor";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Card extends DarkModeHighlightMixin {
  @Prop()
  icon?: string;

  @Prop()
  title?: string;

  @Prop({ default: false })
  hideTitle?: string;

  @Prop()
  subtitle?: string;

  @Prop({ default: true })
  outlined?: boolean;

  @Prop({ default: false })
  hideDivider?: boolean;

  @Prop({ default: 2 })
  margin?: number;

  @Prop({ default: 250 })
  minWidth?: number;

  @Prop()
  width?: string;

  @Prop()
  height?: number;

  @Prop({ default: "" })
  slotClass!: string;

  @Prop({ default: false })
  showGradient?: boolean;

  @Prop({ default: false })
  loading?: boolean;

  @Prop()
  fullscreen?: boolean;

  partnerColor = new PartnerColor();

  get gradientStyle() {
    if (this.showGradient) {
      return this.partnerColor.gradientStyle;
    }
    return "";
  }

  onActionHover(isHovered: boolean) {
    this.$emit("hover:action", isHovered);
  }
}
